import { forwardRef, type MouseEvent } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const Rythme2 = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <path
      fill="none"
      stroke="#B95733"
      strokeMiterlimit="10"
      strokeWidth=".3"
      d="M10.51 9.66v11.1c0 .08.07.15.15.15h2.68c.08 0 .15-.07.15-.15V8.08c0-.1-.11-.17-.2-.12l-2.71 1.58c-.04.03-.07.07-.07.12zm4.28-2.48-.11 13.58c0 .08.06.15.15.15h2.68c.08 0 .15-.07.15-.15V5.65c0-.1-.11-.17-.2-.12l-2.6 1.53a.13.13 0 0 0-.07.12zm4.05-2.38v15.97c0 .08.07.15.15.15h2.68c.08 0 .15-.07.15-.15V3.23c0-.1-.11-.17-.2-.12l-2.71 1.57c-.05.02-.07.07-.07.12z"
    />
    <path
      fill="#B95733"
      d="M2.18 20.69c0 .08.07.15.15.15h2.68c.08 0 .15-.07.15-.15v-7.75c0-.1-.11-.17-.2-.12L2.25 14.4a.14.14 0 0 0-.07.12v6.17zm4.17-8.6v8.67c0 .08.07.15.15.15h2.68c.08 0 .15-.07.15-.15L9.3 10.52c0-.1-.11-.17-.2-.12l-2.68 1.57a.13.13 0 0 0-.07.12z"
    />
  </svg>
));
